const STRUCTURED_AMOUNT_KEYS = [
  "transportationChargesAmount",
  "carTransportationChargesAmount",
  "loadingChargesAmount",
  "unloadingChargesAmount",
  "unpackingRearrangingChargesAmount",
  "shuttleLongCarryEscortChargesAmount",
  "carrierRiskChargesAmount",
];

function hasPositiveStructuredAmount(quotation) {
  for (const k of STRUCTURED_AMOUNT_KEYS) {
    const n = Number(quotation[k]);
    if (Number.isFinite(n) && n > 0) return true;
  }
  return false;
}

/**
 * True when the quotation has saved pricing/PDF content (for UI: icon turns green like job invoice).
 */
export function hasQuotationPricingDetails(quotation) {
  if (!quotation) return false;
  if (hasPositiveStructuredAmount(quotation)) return true;
  const charges = quotation.quotationCharges;
  if (Array.isArray(charges) && charges.length > 0) return true;
  const t = Number(quotation.totalAmount);
  if (Number.isFinite(t) && t > 0) return true;
  const s = Number(quotation.subTotal);
  if (Number.isFinite(s) && s > 0) return true;
  const ref = (quotation.quotationRefNo || "").trim();
  if (ref) return true;
  const from = (quotation.fromLocation || "").trim();
  if (from) return true;
  return false;
}
